import { useEffect, useState } from "react";
import PageHeader from "../../../Layout/PageHeader";
import FormSelect from "../../../Components/FormTag/FormSelect";
import { assignUser } from "../../../Data/dropdownDataList";
import { useForm } from "react-hook-form";
import { Plus, Search } from "react-bootstrap-icons";
import CycleCountByItemFormStructure from "../../../Shared/Forms/CycleCountByItemFormStructure";
import CustomDropdown from "../../../Components/Dropdown/CustomDropdown";
import { addLineItem } from "../../../Data/testData";
import AddLineLayout from "../../../Layout/AddLineLayout";
import { useStore } from "../../../store/Store";
import Table from "../../../Components/Tables/Table";
import FormButton from "../../../Components/Buttons/FormButton";
import CommonModal from "../../../Components/Modals/CommonModal";
import { useNavigate } from "react-router-dom";

function CycleCountByItem() {
  const navigate = useNavigate();
  const pageName = `Cycle Count`;
  const [show, setShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const setSelectedItem = useStore((state) => state.setSelectedItem);
  const selectedItem = useStore((state) => state.selectedItem);
  // Update the data state whenever the selectedItem changes
  useEffect(() => {
    selectedItem && setData(selectedItem);
  }, [selectedItem]);

  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const {
    control,
    formState: { errors },
  } = useForm<typeof assignUser>({
    defaultValues: assignUser,
  });

  // Function to handle item selection, adding the selected item to the selectedItem array
  const handleItemSelect = (item: Record<string, any>) => {
    if (selectedItem) {
      // @temp: Auto increase the line number based on the length of the selectedItem array
      item.Line = (selectedItem.length + 1).toString();
      // If selectedItem exists, append the new item to the array
      setSelectedItem([...selectedItem, item]);
    } else {
      // If selectedItem is empty, set it with the selected item
      setSelectedItem(data);
    }
  };

  const handleMultipleItemAddition = (selectedRows: any[]) => {
    if (selectedItem) {
      let lastLength = selectedItem.length;
      selectedRows.forEach((item: { Line: string }) => {
        lastLength++;
        item.Line = lastLength.toString();
      });
      setSelectedItem([...selectedItem, ...selectedRows]);
    } else {
      // If selectedItem is empty, set it with the selected item
      setSelectedItem(data);
    }
  };

  // State to hold the data for the table
  const [data, setData] = useState<any[]>([]);
  // Configuration for table columns
  const columnsConfig = [
    { columnName: "Item Code", selector: "ItemCode" },
    { columnName: "Item Description", selector: "ItemDescription" },
    { columnName: "Qty on Hand", selector: "quantityOnHand" },
  ];

  const columns = [
    {
      name: "Line No.",
      selector: (row: { Line: string }) => row.Line,
    },
    {
      name: "Item Code",
      selector: (row: any) =>
        data.some((selectedRow) => selectedRow.ItemCode === row.ItemCode) ? (
          row.ItemDescription // Display Item Description if present in data
        ) : (
          <CustomDropdown
            handleSelect={handleItemSelect}
            data={addLineItem}
            selectableColumns={columnsConfig}
            buttonName="Expanded View"
            modalContent={<AddLineLayout />}
          />
        ),
    },
    {
      name: "Item Description",
      selector: (row: { ItemDescription: string }) => row.ItemDescription,
    },
    {
      name: "UOM",
      selector: (row: { UOM: string }) => row.UOM,
    },
    {
      name: "Qty on Hand",
      selector: (row: { quantityOnHand: string }) => row.quantityOnHand,
    },
  ];
  // Ensure a blank row always contains the CustomDropdown
  const blankRow = {
    LineNo: "",
    ItemCode: (
      <CustomDropdown
        handleSelect={handleItemSelect}
        data={addLineItem}
        selectableColumns={columnsConfig}
        buttonName="Expanded View"
        modalContent={<AddLineLayout />}
      />
    ),
    ItemDescription: "",
    UOM: "",
    quantityOnHand: "",
  };
  const inputs = [
    <>
      <label className="fw-medium">Created Date *</label>
      <div className="mt-1">
        <input
          tabIndex={1}
          maxLength={50}
          type="date"
          name="createdDate"
          className="form-control"
          required
        />
      </div>
    </>,
    <>
      <label className="fw-medium">Assigned to</label>
      <div className="mt-1">
        <FormSelect
          name="assignUser"
          tabIndex={1}
          control={control}
          optionList={assignUser}
          required={true}
          className="form-control p-0"
          placeholder={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Search style={{ marginRight: "5px" }} />
              Search
            </div>
          }
          isSearchable={true}
        />
      </div>
    </>,
    <>
      <label className="fw-medium">Schedule Count</label>
      <div className="form-check form-switch sidebar-toggler py-2">
        <input
          className="form-check-input toggle-button-size"
          type="checkbox"
          role="switch"
          id="flexSwitchCheckChecked"
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
      </div>
    </>,
  ];

  return (
    <>
      <PageHeader
        addUrl="/inbound/asn/overview/add"
        listUrl="/inventory/counts/cycle-count"
        viewType={true}
        isHistoryEnabled={true}
        // historyData={[historyData]}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-1">
        <CycleCountByItemFormStructure inputFields={inputs} />
      </div>
      <div className="mb-2 bg-white rounded py-1 px-4 d-flex flex-column h-100">
        <Table
          data={[...data, blankRow]}
          columns={columns}
          enableDeleteRow={true}
          CheckboxStatus={false}
          isStripped={true} 
          customClassName='transferDetailsTable'
        />

        <div className="d-flex align-items-center mt-auto mb-2">
          <div onClick={handleShow} className="d-flex align-items-center">
            <div className="cursor-pointer ms-2 me-2 mb-2 addline-icon d-flex align-items-center justify-content-center">
              <Plus />
            </div>
            <small className="cursor-pointer fw-bold mb-2">Add Line</small>
          </div>
          <CommonModal
          customClassName="header-border"
            modalSize="modal-lg"
            handleClose={handleClose}
            show={show}
            heading="Add Line Items"
            content={
              <AddLineLayout
                handleClose={handleClose}
                handleAddItem={handleMultipleItemAddition}
              />
            } // Pass handleClose as a prop if needed
            // footerButtonsActive={true}
          />
        </div>
      </div>
      <div className=" bg-white rounded py-3 mt-auto">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={3}
            className="sph-btn me-4"
            handleClick={() => {
              navigate("/inventory/counts/cycle-count");
            }}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={4}
            className="sph-btn sph-shift me-4"
            handleClick={() => {
              navigate("/inventory/counts/cycle-count");
            }}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}

export default CycleCountByItem;
